// extracted by mini-css-extract-plugin
export var emailButton = "StaffMember-module--emailButton--2d152";
export var modalContents = "StaffMember-module--modalContents--89367";
export var name = "StaffMember-module--name--e96af";
export var staffMember = "StaffMember-module--staffMember--edcf3";